var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.24 6.15457C17.93 2.52457 14.55 0.43457 10.99 0.43457C9.20999 0.43457 7.47999 0.95457 5.89999 1.92457C4.31999 2.90457 2.89999 4.33457 1.73999 6.15457C0.73999 7.72457 0.73999 10.2746 1.73999 11.8446C4.04999 15.4846 7.42999 17.5646 10.99 17.5646C12.77 17.5646 14.5 17.0446 16.08 16.0746C17.66 15.0946 19.08 13.6646 20.24 11.8446C21.24 10.2846 21.24 7.72457 20.24 6.15457ZM10.99 13.0446C8.74999 13.0446 6.94999 11.2346 6.94999 9.00457C6.94999 6.77457 8.74999 4.96457 10.99 4.96457C13.23 4.96457 15.03 6.77457 15.03 9.00457C15.03 11.2346 13.23 13.0446 10.99 13.0446Z",
    fill: "#234CE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9899 6.14453C9.41989 6.14453 8.13989 7.42453 8.13989 9.00453C8.13989 10.5745 9.41989 11.8545 10.9899 11.8545C12.5599 11.8545 13.8499 10.5745 13.8499 9.00453C13.8499 7.43453 12.5599 6.14453 10.9899 6.14453Z",
    fill: "#234CE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon08);
export default __webpack_public_path__ + "static/media/chat-icon-08.11737803ada2f418e8682b9303c41951.svg";
export { ForwardRef as ReactComponent };